// This hook is reusable for other modals we may build in the future.
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ModalActions, NavigateToDestination } from "../types/hooks.types";

const useModal = (): ModalActions => {
  // Track whether the modal is open.
  const [modalOpen, setModalOpen] = useState(false);
  // Store where the user wants to navigate e.g., to which component.
  const [navigation, setNavigation] = useState<NavigateToDestination | null>(null);
  const navigate = useNavigate();

  // Store the intended navigation destination.
  const openModal = (destination: NavigateToDestination) => {
    setModalOpen(true);
    // Store the destination path, so that we can use it when the user proceeds.
    setNavigation(destination);
  };

  // Close the modal and clear the stored destination.
  const closeModal = () => {
    setModalOpen(false);
    setNavigation(null);
  };

  // Proceed with navigation after the user proceeds.
  const proceedToDestination = () => {
    if (navigation) {
      navigate(navigation);
      closeModal();
    }
  };

  // Return the state and functions so they can be used in a component.
  return {
    modalOpen,
    openModal,
    closeModal,
    proceedToDestination,
  };
};

export default useModal;
